import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Authenticated from "./Components/Guard/Authenticated";
import { lazy, Suspense } from "react";
import OrderSuccess from "./Components/pages/OrderSuccess";
const Home = lazy(() => import("./Components/Home"));
const ProductListing = lazy(() => import("./Components/pages/ProductListing"));
const ProductDetail = lazy(() => import("./Components/pages/ProductDetail"));
const ViewCart = lazy(() => import("./Components/pages/ViewCart"));
const Checkout = lazy(() => import("./Components/pages/Checkout"));
const PaymentSuccessful = lazy(() => import("./Components/pages/PaymentSuccessful"));
const PaymentFailed = lazy(() => import("./Components/pages/PaymentFailed"));
const Signup = lazy(() => import("./Components/pages/Signup"));
const UserDashboard = lazy(() => import("./Components/pages/UserDashboard"));
const MyOrder = lazy(() => import("./Components/pages/MyOrder"));
const TrackOrder = lazy(() => import("./Components/pages/TrackOrder"));
const Wishlist = lazy(() => import("./Components/pages/Wishlist"));
const About = lazy(() => import("./Components/pages/About"));
const Contact = lazy(() => import("./Components/pages/Contact"));
const PrivacyPolicy = lazy(() => import("./Components/pages/PrivacyPolicy"));
const PageNotFound = lazy(() => import("./Components/common/PageNotFound"));
const RateUs = lazy(() => import("./Components/pages/RateUs"));

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-muted">Loading page...</p>
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/product-listing/:cId?" element={<ProductListing />} />
            <Route path="/product-detail/:id?" element={<ProductDetail />} />
            <Route path="/view-cart" element={<ViewCart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/dashboard" element={
              <Authenticated>
                <UserDashboard />
              </Authenticated>
            } />
            <Route path="/my-order" element={<Authenticated>
              <MyOrder />
            </Authenticated>}
            />
            <Route path="/rate-us" element={<Authenticated>
              <RateUs />
            </Authenticated>}
            />
            <Route path="/my-order/track-order/:orderId" element={<Authenticated>
              <TrackOrder />
            </Authenticated>}
            />
            <Route path="/order-success" element={<Authenticated>
              <OrderSuccess />
            </Authenticated>}
            />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/about" element={<About />} />
            <Route path="/pre-order" element={<Contact isBillNo={true} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cms/:slug" element={<PrivacyPolicy />} />
          </Route>
          <Route path="/signup" element={<Signup />} />
          <Route path="/payment-success/:id?" element={<PaymentSuccessful />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
